<template>
  <div>
    <b-overlay
        id="overlay-background"
        :show="isLoading"
        :opacity="0.6"
        variant="light"
        rounded="sm"
    >
    <!-- Filters -->
    <users-list-filters
      :status-filter.sync="statusFilter"
      :status-options="statusOptions"
    />

    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      hidden
      title="Notificação em Massa"
      variant="success"
      class="btn-icon"
      @click="sendNotificacaoMassa"
    >
      <feather-icon
        icon="BellIcon"
      />

    </b-button>

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row class="justify-content-end">

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div

              class="d-flex align-items-center justify-content-end"
            >
              <b-form-input
                id="filter-all-usuario"
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Pesquisar..."
              />
            </div>
          </b-col>
        </b-row>

      </div>
      <div id="table-list-users">
        <b-table

          ref="refUserListTable"
          class="position-relative"
          :items="findAllPagamentos"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc"
        >

          <template #head(actions)="data">
            <div class="text-center">
              <span>{{ data.label }}</span>
            </div>
          </template>

          <!-- Column: Total View -->
          <template #cell(total_view)="data">
            <div class="text-center">
              <span>{{ data.value }}</span>
            </div>
          </template>

          <!-- Column: Total VSL -->
          <template #cell(total_vsl)="data">
            <div class="text-center">
              <span>{{ data.value }}</span>
            </div>
          </template>

          <!-- Column: Total CHats -->
          <template #cell(total_chat)="data">
            <div class="text-center">
              <span>{{ data.value }}</span>
            </div>
          </template>

          <!-- Column: Data Compra -->
          <template #cell(dt_compra)="data">
            <div class="text-center">
              <span>{{ data.value | formatDateBr }}</span>
            </div>
          </template>

          <!-- Column: Data Validade -->
          <template #cell(dt_validade)="data">
            <div class="text-center">
              <span>{{ data.value | formatDateBr }}</span>
            </div>
          </template>

          <!-- Column: User -->
          <template #cell(user)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                  size="32"
                  :src="data.item.avatar"
                  :text="avatarText(data.item.fullName)"
                  :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
                  :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
                />
              </template>
              <b-link
                :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
                class="font-weight-bold d-block text-nowrap"
              >
                {{ data.item.fullName }}
              </b-link>
              <small class="text-muted">@{{ data.item.username }}</small>
            </b-media>
          </template>

          <!-- Column: Status -->
          <template #cell(user_ativo)="data">
            <b-badge
              pill
              :variant="`light-${resolveUserStatusVariant(data.value)}`"
              class="text-capitalize"
            >
              <strong>{{ resolveUserStatusLabel(data.value) }}</strong>
            </b-badge>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="d-flex">
              <div class="d-flex flex-column text-center justify-content-center mr-1">
                <b-card-text
                  v-b-tooltip.hover.top="formatDateBr(data.item.data_primeira_cobranca)"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  class="mb-0"
                >
                  <strong>1° Cobrança</strong>
                </b-card-text>
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :variant="data.item.data_primeira_cobranca === null ? 'warning' : 'success'"
                  class="btn-icon"
                  :disabled="hasPassed30Days(data.item.dt_validade) && data.item.data_primeira_cobranca !== null || data.item.total_view < 10"
                  @click="sendPrimeiraCobranca(data.item)"
                >
                  <feather-icon
                    v-if="data.item.data_primeira_cobranca === null"
                    icon="SendIcon"
                  />
                  <feather-icon
                    v-else
                    icon="CheckCircleIcon"
                  />
                </b-button>
              </div>
              <div class="d-flex flex-column text-center justify-content-center mr-1">
                <b-card-text
                  v-b-tooltip.hover.top="formatDateBr(data.item.data_segunda_cobranca)"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  class="mb-0"
                >
                  <strong>2° Cobrança</strong>
                </b-card-text>
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :variant="data.item.data_segunda_cobranca === null ? 'warning' : 'success'"
                  class="btn-icon"
                  :disabled="hasPassed30Days(data.item.dt_validade) < 7 || data.item.data_segunda_cobranca !== null || data.item.total_view < 10"
                  @click="sendSegundaCobranca(data.item)"
                >
                  <feather-icon
                    v-if="data.item.data_segunda_cobranca === null"
                    icon="SendIcon"
                  />
                  <feather-icon
                    v-else
                    icon="CheckCircleIcon"
                  />
                </b-button>
              </div>

              <div
                v-if="data.item.data_primeira_cobranca !== null && data.item.data_segunda_cobranca !== null && hasPassed30Days(data.item.dt_validade) > 13"
                class="d-flex flex-column text-center justify-content-center"
              >
                <b-card-text class="mb-0">
                  <strong>Bloquear Conta</strong>
                </b-card-text>
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :title="`${data.item.user_ativo === 1 ? 'Bloquear' : 'Desbloquear'} Conta`"
                  :variant="data.item.user_ativo === 1 ? 'success' : 'danger'"
                  class="btn-icon"
                  :disabled="((hasPassed30Days(data.item.dt_validade) && data.item.data_primeira_cobranca !== null) && (hasPassed30Days(data.item.dt_validade) && data.item.data_primeira_cobranca === null || data.item.status !== 2 || data.item.user_ativo === 0) && data.item.data_primeira_cobranca!==null && data.item.data_segunda_cobranca===null) || data.item.total_view < 10"
                  @click="bloqueiaUsuario(data.item)"
                >
                  <feather-icon
                    v-if="data.item.user_ativo === 1"
                    icon="UserCheckIcon"
                  />
                  <feather-icon
                    v-else
                    icon="SlashIcon"
                  />
                </b-button>
              </div>

              <div
                v-else
                class="d-flex flex-column text-center justify-content-center"
              >
                <b-card-text class="mb-0">
                  <strong>Bloquear Conta</strong>
                </b-card-text>
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :title="`${data.item.user_ativo === 1 ? 'Bloquear' : 'Desbloquear'} Conta`"
                  :variant="data.item.user_ativo === 1 ? 'success' : 'danger'"
                  class="btn-icon"
                  disabled
                >
                  <feather-icon
                    v-if="data.item.user_ativo === 1"
                    icon="UserCheckIcon"
                  />
                  <feather-icon
                    v-else
                    icon="SlashIcon"
                  />
                </b-button>
              </div>
            </div>
          </template>

        </b-table>
      </div>

      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{
              dataMeta.of
            }} entries</span>
          </b-col>

        </b-row>
      </div>
    </b-card>
    </b-overlay>
    <ModalConfirmation
      title="Confirmação de exclusão do usuário"
      @okDeleteFluxoChat="onSubmitDelete"
    >
      <template #content-message>
        Tem certeza de que deseja <strong>excluir</strong> este usuário?
      </template>
    </ModalConfirmation>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BPagination, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import {computed, ref} from '@vue/composition-api'
import { avatarText, formatDateBr } from '@core/utils/filter'
import UsersListFilters from '@/views/App/Usuarios/usuarios-lista/UsersListFilters.vue'
import usePagamentosList from '@/views/App/Pagamentos/usePagamentosList'
import ModalConfirmation from '@/components/ModalConfirmation.vue'
import Swal from 'sweetalert2'
import axios from '@axios'

export default {
  components: {
    ModalConfirmation,
    UsersListFilters,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BPagination,
    vSelect,
  },
  filters: {
    formatDateBr,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  setup() {
    const userItem = ref(null)
    const isAddNewUserSidebarActive = ref(false)
    const isLoading = computed({
      get: () => store.getters['storePagamentos/loading'],
      set: val => store.commit('storePagamentos/SET_LOADING', val),
    })

    const sendNotificacaoMassa = async () => {
      await axios.get('/get/usuarios?perPage=1000&currentPage=1')
        .then(resp => {
          const allUsers = resp.data.users
          allUsers.forEach(user => {
            console.log('user', user)
            store.dispatch('storeNotifications/sendNotifications', {
              titulo: 'Bem-vindo(a)!',
              descricao: `Olá ${user.username}, seja bem-vindo(a) à nossa plataforma. Estamos felizes por tê-lo(a) conosco! Explore nossos serviços e conte com o nosso suporte sempre que precisar.`,
              id_user: user.id,
              type: 'success',
              link: '#',
              target: false,
              evento: 'user.welcome',
            })
          })
        })
    }

    const roleOptions = [
      { label: 'Admin', value: 'admin' },
      { label: 'Cliente', value: 'client' },
    ]

    const planOptions = [
      { label: 'Vsl-Booster', value: 'VSL Booster' },
      { label: 'Pro-Booster', value: 'PRO Booster' },

    ]

    const statusOptions = [
      { label: 'Ativo', value: '1' },
      { label: 'Inativo', value: '0' },
      { label: 'Todos', value: null },
    ]

    const onSubmitDelete = () => {
      (async () => {
        if (userItem.value.fileKey !== null) {
          // eslint-disable-next-line no-use-before-define
          await onSubmitDeleteAws(userItem.value.fileKey)
        }
      })()

      store.dispatch('storePagamentos/findAll', userItem.value.id)
        .then(() => {
          // eslint-disable-next-line no-use-before-define
          refetchData()
        })
    }
    const onSubmitDeleteAws = userFileKey => {
      store.dispatch('app-user/deleteUserAws', userFileKey)
        .then(res => {
          console.log('resAWS', res)
          // eslint-disable-next-line no-use-before-define
        })
    }

    const sendPrimeiraCobranca = user => {
      console.log('[sendPrimeiraCobranca]- user', user)
      userItem.value = user
      store.dispatch('storeNotifications/sendNotifications', {
        titulo: '1° Cobrança',
        descricao: 'Sua primeira cobrança está pendente. Por favor, efetue o pagamento o mais breve possível.',
        id_user: user.id_user,
        type: 'warning',
        // link: `/payment?uuid=${user.uuid}`,
        link: 'https://pay.kiwify.com.br/UETSK0M',
        target: true,
        evento: 'cobranca.primeira',
      })
      store.dispatch('storePagamentos/primeiraCobranca', { id: user.id_user, data: user })
        .then(resp => {
          isLoading.value = false
          Swal.fire(
            '1° Cobrança!',
            resp.data.message,
            'success',
          )
          // eslint-disable-next-line no-use-before-define
          refetchData()
        })
        .catch(err => {
          Swal.fire(
            'Erro!',
            'Não foi possível enviar a cobrança.',
            'error',
          )
        })
    }

    const sendSegundaCobranca = user => {
      userItem.value = user
      isLoading.value = true
      store.dispatch('storeNotifications/sendNotifications', {
        titulo: '2° Cobrança',
        descricao: 'Nova cobrança disponível para sua conta. Verifique o pagamento para evitar interrupções nos serviços.',
        id_user: user.id_user,
        type: 'warning',
        // link: `/payment?uuid=${user.uuid}`,
        link: 'https://pay.kiwify.com.br/UETSK0M',
        target: true,
        evento: 'cobranca.segunda',
      })
      store.dispatch('storePagamentos/segundaCobranca', { id: user.id_user, data: user })
        .then(resp => {
          isLoading.value = false
          Swal.fire(
            '2° Cobrança!',
            resp.data.message,
            'success',
          )
          // eslint-disable-next-line no-use-before-define
          refetchData()
        })
        .catch(err => {
          Swal.fire(
            'Erro!',
            err.response.data.message,
            'error',
          )
        })
          .finally(() => {
            isLoading.value = false
          })
    }

    const bloqueiaUsuario = user => {
      isLoading.value = true
      if (user.user_ativo === 0) {
        Swal.fire({
          title: 'Desbloquear usuário',
          text: 'Tem certeza que deseja desbloquear este usuário?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Desbloquear',
        }).then(result => {
          if (result.isConfirmed) {
            userItem.value = user
            store.dispatch('storePagamentos/bloqueiaUsuario', { id: user.id_user, data: user })
              .then(() => {
                isLoading.value = false
                Swal.fire(
                  'Desbloqueado!',
                  'O usuário foi desbloqueado.',
                  'success',
                )
                store.dispatch('storeNotifications/sendNotifications', {
                  titulo: `Bem-vindo(a) ${user.user_name}! Sua conta está ativada!`,
                  descricao: 'Sua conta foi ativada com sucesso. Aproveite todos os recursos disponíveis.',
                  id_user: user.id_user,
                  type: 'success',
                  link: '#',
                  target: false,
                  evento: 'user.ativo',
                })
                // eslint-disable-next-line no-use-before-define
                refetchData()
              })
              .catch(err => {
                Swal.fire(
                  'Erro!',
                  err.response.data.message,
                  'error',
                )
              })
                .finally(() => {
                  isLoading.value = false
                })
          }
        })
        return
      }
      Swal.fire({
        title: 'Bloquear usuário',
        text: 'Tem certeza que deseja bloquear este usuário?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Bloquear',
      }).then(result => {
        if (result.isConfirmed) {
          userItem.value = user
          console.log('[bloqueiaUsuario]- user', user)
          store.dispatch('storePagamentos/bloqueiaUsuario', { id: user.id_user, data: user })
            .then(() => {
              Swal.fire(
                'Bloqueado!',
                'O usuário foi bloqueado.',
                'success',
              )
              store.dispatch('storeNotifications/sendNotifications', {
                titulo: 'Aviso de Bloqueio de Conta',
                descricao: 'Sua conta está bloqueada devido a atraso no pagamento. Regularize a situação para evitar suspensão temporária.',
                id_user: user.id_user,
                type: 'danger',
                // link: `/payment?uuid=${user.uuid}`,
                link: 'https://pay.kiwify.com.br/UETSK0M',
                target: true,
                evento: 'user.blocked',
              })
              // eslint-disable-next-line no-use-before-define
              refetchData()
            })
            .catch(err => {
              Swal.fire(
                'Erro!',
                err.response.data.message,
                'error',
              )
            })
        }
      })
    }

    const {
      findAllPagamentos,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      resolveUserStatusLabel,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,

      hasPassed30Days,
    } = usePagamentosList()

    return {
      onSubmitDeleteAws,
      onSubmitDelete,
      // Sidebar
      isAddNewUserSidebarActive,
      findAllPagamentos,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,
      formatDateBr,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      resolveUserStatusLabel,

      roleOptions,
      planOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
      userItem,
      sendPrimeiraCobranca,
      sendSegundaCobranca,
      bloqueiaUsuario,

      hasPassed30Days,
      isLoading,
      sendNotificacaoMassa,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
